import React, { useRef, useEffect } from "react";
import { Bold, Italic, Underline, List, ListOrdered, Link2, Heading2, Eraser } from "lucide-react";
import { cn } from "@/lib/utils";

export function RichTextEditor({ value, onChange, className, placeholder = "Escribe o pega el contenido aquí…" }) {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current && ref.current.innerHTML !== (value || "")) {
      ref.current.innerHTML = value || "";
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const emit = () => onChange?.(ref.current?.innerHTML || "");
  const exec = (cmd, arg) => { document.execCommand(cmd, false, arg); ref.current?.focus(); emit(); };
  const addLink = () => { const url = window.prompt("URL del enlace:"); if (url) exec("createLink", url); };

  const Btn = ({ icon: Icon, onClick, title, testid }) => (
    <button type="button" title={title} data-testid={testid} onMouseDown={(e) => e.preventDefault()} onClick={onClick}
      className="rounded p-1.5 text-muted-foreground transition-colors hover:bg-muted hover:text-foreground">
      <Icon className="h-4 w-4" />
    </button>
  );

  return (
    <div className={cn("overflow-hidden rounded-lg border", className)}>
      <div className="flex flex-wrap items-center gap-0.5 border-b bg-muted/30 p-1">
        <Btn icon={Heading2} title="Título" testid="rte-h3" onClick={() => exec("formatBlock", "<h3>")} />
        <Btn icon={Bold} title="Negrita" testid="rte-bold" onClick={() => exec("bold")} />
        <Btn icon={Italic} title="Cursiva" testid="rte-italic" onClick={() => exec("italic")} />
        <Btn icon={Underline} title="Subrayado" testid="rte-underline" onClick={() => exec("underline")} />
        <span className="mx-1 h-4 w-px bg-border" />
        <Btn icon={List} title="Lista" testid="rte-ul" onClick={() => exec("insertUnorderedList")} />
        <Btn icon={ListOrdered} title="Lista numerada" testid="rte-ol" onClick={() => exec("insertOrderedList")} />
        <Btn icon={Link2} title="Enlace" testid="rte-link" onClick={addLink} />
        <span className="mx-1 h-4 w-px bg-border" />
        <Btn icon={Eraser} title="Quitar formato" testid="rte-clear" onClick={() => exec("removeFormat")} />
      </div>
      <div ref={ref} contentEditable suppressContentEditableWarning data-testid="rich-editor"
        onInput={emit} data-placeholder={placeholder}
        className="hr-content min-h-[260px] max-w-none px-4 py-3 focus:outline-none" />
    </div>
  );
}
